import React from 'react';
import PropTypes from "prop-types";
import {useFormik} from "formik";

import {ResponsiveDialog} from "../../../../../components/ResponsiveDialog";
import guestsValidationSchema from "./validator";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";

const FormEditGuests = (props) => {
    const {booking, isLoading, onSubmit, onClose} = props;

    const formik = useFormik({
        initialValues: {
            adults: booking.adults || '',
            children: booking.children || 0,
            petsNumber: booking.petsNumber || 0,
        },
        validationSchema: guestsValidationSchema,
        onSubmit: values => {
            onSubmit(values);
        }
    });

    const submitIsEnabled = !Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <ResponsiveDialog title={"Modifica ospiti"}
                          isOpen={true}
                          maxWidth="md"
                          scroll="paper"
                          isLoading={isLoading}
                          showApply={true}
                          applyLabel="Salva"
                          enableApply={submitIsEnabled}
                          onApply={formik.handleSubmit}
                          closeLabel="Cancella"
                          onClose={onClose}>
            <Grid container spacing={3} sx={{mt: 2}}>
                <Grid item xs={12} md={6}>
                    <TextField type="number"
                               label="Numero adulti"
                               fullWidth
                               name="adults"
                               required
                               value={formik.values.adults}
                               onChange={formik.handleChange}
                               error={formik.touched.adults && Boolean(formik.errors.adults)}
                               helperText={formik.touched.adults && formik.errors.adults}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField type="number"
                               label="Numero bambini"
                               fullWidth
                               name="children"
                               required
                               value={formik.values.children}
                               onChange={formik.handleChange}
                               error={formik.touched.children && Boolean(formik.errors.children)}
                               helperText={formik.touched.children && formik.errors.children}/>
                </Grid>

                <Grid item xs={12}>
                    <TextField type="number"
                               label="Numero animali domestici"
                               fullWidth
                               name="petsNumber"
                               required
                               value={formik.values.petsNumber}
                               onChange={formik.handleChange}
                               error={formik.touched.petsNumber && Boolean(formik.errors.petsNumber)}
                               helperText={formik.touched.petsNumber && formik.errors.petsNumber}/>
                </Grid>
            </Grid>

        </ResponsiveDialog>
    );
};

FormEditGuests.propTypes = {
    booking: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default FormEditGuests;